import { create } from 'zustand'

export type MissingFieldsSheetParams = {
  brandId: number | string
  customerId: number | string
  customerName?: string
  customerPhoneNumber?: string | number
  brandName?: string
  leadSource?: string
  variantId?: number | string
  generateLinkParams?: object
}

type IMissingFieldsSheet = {
  sheetParams: MissingFieldsSheetParams | null
  openSheet: (payload: MissingFieldsSheetParams) => void
  closeSheet: () => void
}

const useMissingFieldsSheetStore = create<IMissingFieldsSheet>((set) => ({
  sheetParams: null,
  openSheet: (payload) => set(() => ({ sheetParams: payload })),
  closeSheet: () => set(() => ({ sheetParams: null })),
}))

export default useMissingFieldsSheetStore
